import { ApiClient } from '@api/api-configuration';
import useSmartErrorHandling from '@hooks/useSmartErrorHandling';
import { useCallback } from 'react';

/**
 * Hook that provides a callback function for registering FCM tokens with the backend API
 *
 * This hook creates a callback that will be called by the WebPushProvider whenever
 * an FCM token is received. It handles the API call to register the token with the
 * user's account.
 */
export const useWebPushApiCallback = () => {
  const { handleError } = useSmartErrorHandling();

  const onToken = useCallback(
    async (token: string): Promise<void> => {
      try {
        await ApiClient.notificationsApi.notifications.registerNotificationToken({
          deviceToken: token,
          platform: 'web',
          deviceInfo: navigator?.userAgent,
        });

        console.log('WebPush: Token registered successfully');
      } catch (error) {
        console.error('WebPush: Failed to register token', error);
        handleError(error as Error, {
          customMessage: 'Failed to register notification token',
          forceShow: false,
        });
      }
    },
    [handleError]
  );

  return onToken;
};
